import React, {
  Component
} from 'react';
import {
  connect
} from 'react-redux';
import {
  push,
  replace
} from 'react-router-redux';
import {
  Container,
  Image,
  Label,
  Segment
} from 'semantic-ui-react';
import {
  Link
} from 'react-router-dom';
import feathersConnect from './../../providers/feathersConnect';

class InstitutionalView extends Component {

  constructor (props) {
    super(props);
  }

  componentDidMount () {

  }

  static mapStateToProps (state) {
    return {
      routing: state.routing,
      authentication: state.authentication.toJS({ deep: true })
    };
  }

  static mapDispatchToProps (dispatch) {
    return {
      navigate: (path) => {
        dispatch(push(path));
      }
    };
  }

  render () {
    return (
      <Container style={{ padding: 16 }}>
        <Segment vertical textAlign="center">
          <Label basic color="red">Sitio en Desarrollo</Label>
          <h1>Institucional</h1>
        </Segment>
      </Container>
    );
  }
}

export default feathersConnect(
  connect(
    InstitutionalView.mapStateToProps,
    InstitutionalView.mapDispatchToProps
  )(InstitutionalView)
);



// WEBPACK FOOTER //
// ./client/components/pages/InstitutionalView.js